export const DEFAULT_PAGE_NUMBER = 0;
export const ITEMS_PER_PAGE = 10;
export const PROBLEMATIC_ID = 'problematic';
export const CONFIRMED_ID = 'confirmed';
export const CANCELED_ID = 'canceled';
export const DEADHEAD_ID = 'deadhead';
export const DEADHEAD_SEARCH = 'deadheadSearch';
export const RIDE_SEARCH = 'rideSearch';
export const NA_LABEL = 'N/A';
export const VEHICLE_TYPE_BUS = 'bus';

// Mapped WA Statuses based on deadhead values
export const CREW_MEMBER_STATUSES = {
	COMPLETED: 'Actual',
	IN_PROGRESS: 'Confirmed',
};

export const TABS_MODS = new Map(
	Object.entries({
		problematic: {
			label: 'Problematic assigments',
			tabId: PROBLEMATIC_ID,
			panelId: 'ridelist-problematic',
		},
		confirmed: {
			label: 'Confirmed assigments',
			tabId: CONFIRMED_ID,
			panelId: 'ridelist-confirmed',
		},
		canceled: {
			label: 'Canceled rides',
			tabId: CANCELED_ID,
			panelId: 'ridelist-canceled',
		},
		deadhead: {
			label: 'Deadheads',
			tabId: DEADHEAD_ID,
			panelId: 'ridelist-deadhead',
		},
	})
);
